import React from "react";
import { Box, Container, HStack, VStack } from "@chakra-ui/react";
import TraitsPreviewContainer from "containers/TraitsPreviewContainer";
import TraitsSelectorContainer from "containers/TraitsSelectorContainer";
import DressingRoomProvider from "providers/DressingRoomProvider";
import TraitsHangerContainer from "containers/TraitsHangerContainer";
import useAssets from "hooks/useAssets";
import V2SelectorContainer from "containers/V2SelectorContainer";
import V2Provider from "providers/V2Provider";
import V2Context from "contexts/V2Context";
import TraitCard from "components/TraitCard";
import TraitsControlsContainer from "containers/TraitsControlsContainer";
import useTraits from "hooks/useTraits";
import Panel from "components/Panel";

const WardrobePage: React.FC = () => {
  const { traitsInWallet } = useAssets();
  const { traitsByTokenId } = useTraits();

  return (
    <V2Provider>
      <Container pt="12" pb="16">
        <VStack spacing="3" align="flex-start">
          <V2Context.Consumer>
            {({ metadata }) => (
              <DressingRoomProvider
                originalTraits={metadata?.traits || []}
                availableTraits={traitsInWallet}
              >
                <Panel>
                  <VStack spacing="3">
                    <HStack
                      justify="space-between"
                      w="full"
                      spacing={{
                        base: "0",
                        sm: "8",
                      }}
                    >
                      <V2SelectorContainer basePath="/wardrobe" />

                      <TraitsControlsContainer />
                    </HStack>

                    <TraitsPreviewContainer />

                    <TraitsSelectorContainer
                      renderItem={(
                        tokenId,
                        isSelected,
                        isOriginal,
                        isVisible
                      ) => {
                        const trait = traitsByTokenId[tokenId];

                        return trait ? (
                          <Box p="2px">
                            <TraitCard
                              key={tokenId}
                              tokenId={tokenId}
                              isSelected={isOriginal || isSelected}
                              isActive={isOriginal}
                              isVisible={isVisible}
                              imageSize="256"
                            />
                          </Box>
                        ) : (
                          <></>
                        );
                      }}
                    />
                  </VStack>
                </Panel>

                <TraitsHangerContainer />
              </DressingRoomProvider>
            )}
          </V2Context.Consumer>
        </VStack>
      </Container>
    </V2Provider>
  );
};

export default WardrobePage;
